module.exports = __webpack_public_path__ + "img/ambassador.d7f10075.png";